import { render, staticRenderFns } from "./MSSafe.vue?vue&type=template&id=853956b8&scoped=true"
import script from "./MSSafe.vue?vue&type=script&lang=js"
export * from "./MSSafe.vue?vue&type=script&lang=js"
import style0 from "./MSSafe.vue?vue&type=style&index=0&id=853956b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "853956b8",
  null
  
)

export default component.exports